export const SCAN_EVENT_TEST_ID = 'ScanEvent';
export const SCAN_EVENT_DESC_TEST_ID = 'ScanEventDesc';
export const SCAN_EVENT_LOCATION_TIME_TEST_ID = 'ScanEventLocationTimestamp';
